<div class="bulk-update-modal" aria-labelledby="bulk-update-modal-title">
  <h2 id="bulk-update-modal-title" class="modal-title">
    {{ isSla ? "SLA Bulk Update" : "Bulk Update by Product Subtype" }}
  </h2>
  <mat-dialog-content class="modal-content">
    <form [formGroup]="form" class="bulk-update-form">
      @if (!isSla) {
        <div class="field-wrapper">
          <label class="field-label" for="product-subtype"
            >Product Subtype</label
          >
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded"
            [class.field-input-pricing]="isPricing"
            [class.field-input-vendor]="isVendor"
          >
            <mat-select
              formControlName="productSubtype"
              id="product-subtype"
              placeholder="Select option"
            >
              @for (subtype of data.productSubtypes; track subtype) {
                <mat-option [value]="subtype">{{ subtype }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (isPricing) {
        <div class="field-wrapper">
          <label class="field-label" for="new-price">New</label>
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded field-input-pricing"
          >
            <span matPrefix>$</span>
            <input
              matInput
              type="number"
              formControlName="newPrice"
              id="new-price"
              placeholder="-"
              step="1"
              min="0"
            />
          </mat-form-field>
        </div>
        <div class="field-wrapper">
          <label class="field-label" for="update-price">Update</label>
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded field-input-pricing"
          >
            <span matPrefix>$</span>
            <input
              matInput
              type="number"
              formControlName="updatePrice"
              id="update-price"
              placeholder="-"
              step="1"
              min="0"
            />
          </mat-form-field>
        </div>
      }
      @if (isVendor) {
        @for (vendor of vendors; track vendor.vendorID) {
          <div class="field-wrapper">
            <label class="field-label" [for]="'vendor-' + vendor.vendorID"
              >{{ vendor.vendorName }} (%)</label
            >
            <mat-form-field
              appearance="outline"
              class="field-input field-input-rounded field-input-vendor"
            >
              <input
                matInput
                type="number"
                [formControlName]="getVendorControlName(vendor.vendorID)"
                [id]="'vendor-' + vendor.vendorID"
                placeholder="-"
                step="1"
                min="0"
                max="100"
              />
            </mat-form-field>
          </div>
        }
      }
      @if (isSla) {
        <div class="field-wrapper">
          <label class="field-label" for="contract">Contract</label>
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded field-input-sla"
          >
            <input
              matInput
              type="number"
              formControlName="contract"
              id="contract"
              placeholder="-"
              step="1"
              min="0"
            />
          </mat-form-field>
        </div>
        <div class="field-wrapper">
          <label class="field-label" for="target">Target</label>
          <mat-form-field
            appearance="outline"
            class="field-input field-input-rounded field-input-sla"
          >
            <input
              matInput
              type="number"
              formControlName="target"
              id="target"
              placeholder="-"
              step="1"
              min="0"
            />
          </mat-form-field>
        </div>
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions" align="end">
    <button
      mat-raised-button
      type="button"
      class="apply-button modal-button"
      [disabled]="!canApply"
      (click)="onApply()"
    >
      Apply to all
    </button>
    <button
      mat-button
      type="button"
      class="cancel-button modal-button"
      (click)="onCancel()"
    >
      Cancel
    </button>
  </mat-dialog-actions>
</div>
